import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateResourceDefinition',
    pure: false
})

export class TranslateResourceDefinitionPipe implements PipeTransform{
    transform(value : any, table: any, key: string, displayText: string, groupName: string){
        let result : string = value;
        let groupNameAccess = ["NAME", "NOTE", "TEXT", "CONTRACT_EXPIRATION_DT", "USERNAME"]
        if(table != undefined)
        {
            table.forEach(element => {
                if(groupNameAccess.indexOf(value) >= 0){                    
                    if(value == element[key] && element.GROUP_NAME == groupName){
                        result =  element[displayText];
                    }
                } else {
                    if(value == element[key]){
                        result =  element[displayText];
                    }
                }
            });
        }
        return result;
    }
}